import { render, staticRenderFns } from "./SimpleHeaderBackground.vue?vue&type=template&id=6e075262&scoped=true&name=simple-header-background&"
import script from "./SimpleHeaderBackground.vue?vue&type=script&lang=js&"
export * from "./SimpleHeaderBackground.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeaderBackground.vue?vue&type=style&index=0&id=6e075262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e075262",
  null
  
)

export default component.exports